import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectPerimetrosChecadaItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarPerimetros = debounce(this.buscarPerimetros.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarPerimetros('');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const faltantes = this.valoresSeleccionados().filter(
        (id) => !this.state.opciones.some((perimetro) => perimetro._id.toString() === id.toString())
      );
      if (faltantes.length) {
        this.buscarPerimetros('');
      }
    }
  }

  valoresSeleccionados() {
    if (!this.props.value) return [];
    return Array.isArray(this.props.value) ? this.props.value : [this.props.value];
  }

  async buscarPerimetros(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "perimetrosChecada/selectPerimetrosChecadaItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.valoresSeleccionados(),
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.perimetros,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [], primerCarga: true });
      }
    } catch (error) {
      this.setState({ opciones: [] });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false });
    }
  }

  render() {
    const {
      noBuscar,
      disabled,
      sinBorde,
      width,
      style,
      placeholder,
      empresaId,
      headersToken,
      ...restProps
    } = this.props;

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? 'white' : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        showSearch={!noBuscar}
        filterOption={false}
        mode="multiple"
        maxTagCount="responsive"
        onSearch={this.buscarPerimetros}
        notFoundContent={this.state.cargando ? (
          <div style={{ textAlign: 'center', padding: '8px', fontSize: '12px', color: '#999' }}>
            Buscando perímetros...
          </div>
        ) : this.state.primerCarga ? 'No se encontraron perímetros' : null}
        loading={this.state.cargando}
        {...restProps}
        onChange={(value) => {
          const perimetros = this.state.opciones.filter((perimetro) => value.includes(perimetro._id));
          if (this.props.onChange) this.props.onChange(value, perimetros);
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((perimetro) => (
          <Option key={perimetro._id} value={perimetro._id} disabled={perimetro.estado === 2}>
            {perimetro.estado === 2 ? perimetro.stringBuscar + " (deshabilitado)" : perimetro.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectPerimetrosChecadaItem;
